module.exports = __webpack_public_path__ + "img/Television.801635a5.jpg";